export const actionType = {
  REMOVE_TOAST: "REMOVE_TOAST",

  GET_PRODUCTS: "GET_PRODUCTS",
  GET_PRODUCTS_SUCCESS: "GET_PRODUCTS_SUCCESS",
  GET_PRODUCTS_FAILED: "GET_PRODUCTS_FAILED",

  GET_ALL_PRODUCTS: "GET_ALL_PRODUCTS",
  GET_ALL_PRODUCTS_SUCCESS: "GET_ALL_PRODUCTS_SUCCESS",
  GET_ALL_PRODUCTS_FAILED: "GET_ALL_PRODUCTS_FAILED",

  CREATE_PRODUCT: "CREATE_PRODUCT",
  CREATE_PRODUCT_SUCCESS: "CREATE_PRODUCT_SUCCESS",
  CREATE_PRODUCT_FAILED: "CREATE_PRODUCT_FAILED",

  UPDATE_PRODUCT: "UPDATE_PRODUCT",
  UPDATE_PRODUCT_SUCCESS: "UPDATE_PRODUCT_SUCCESS",
  UPDATE_PRODUCT_FAILED: "UPDATE_PRODUCT_FAILED",

  DELETE_PRODUCT: "DELETE_PRODUCT",
  DELETE_PRODUCT_SUCCESS: "DELETE_PRODUCT_SUCCESS",
  DELETE_PRODUCT_FAILED: "DELETE_PRODUCT_FAILED",
}

const initialState = {
  data: null,
  data_all: null,
  meta: null,
  isLoading: false,
  toast: null
}

export default (state = initialState, action) => {
  switch (action.type) {
    case actionType.REMOVE_TOAST:
      return Object.assign({}, state, { toast: null })
    case actionType.GET_PRODUCTS:
    case actionType.GET_ALL_PRODUCTS:
    case actionType.CREATE_PRODUCT:
    case actionType.UPDATE_PRODUCT:
    case actionType.DELETE_PRODUCT:
      return Object.assign({}, state, {
        isLoading: true, errors: null
      });
    case actionType.GET_PRODUCTS_FAILED:
    case actionType.GET_ALL_PRODUCTS_FAILED:
    case actionType.CREATE_PRODUCT_FAILED:
    case actionType.UPDATE_PRODUCT_FAILED:
    case actionType.DELETE_PRODUCT_FAILED:
      return Object.assign({}, state, {
        isLoading: true, errors: action.errors
      });
    case actionType.GET_PRODUCTS_SUCCESS:
      return Object.assign({}, state, {
        data: action.payload.data,
        meta: action.payload.meta,
        isLoading: false,
        error: false
      })
    case actionType.GET_ALL_PRODUCTS_SUCCESS:
      return Object.assign({}, state, {
        data_all: action.payload.data,
        isLoading: false,
        error: false
      })
    case actionType.CREATE_PRODUCT_SUCCESS:
      return Object.assign({}, state, {
        isLoading: false,
        error: false,
        toast: { type: "success", message: "Successfully Added Product" }
      })
    case actionType.UPDATE_PRODUCT_SUCCESS:
      return Object.assign({}, state, {
        isLoading: false,
        error: false,
        toast: {
          type: "success",
          message: "Successfully Updated Product"
        }
      })
    case actionType.DELETE_PRODUCT_SUCCESS:
      return Object.assign({}, state, {
        isLoading: false,
        error: false,
        toast: { type: "success", message: "Successfully Deleted Product" }
      })
    default:
      return state
  }
}

export const actionCreators = {
  removeToast: () => ({ type: actionType.REMOVE_TOAST }),
  getProducts: (id, params) => ({
    type: actionType.GET_PRODUCTS,
    id,
    params
  }),
  getAllProducts: id => ({
    type: actionType.GET_ALL_PRODUCTS, id
  }),
  createProduct: (company_id, body) => ({
    type: actionType.CREATE_PRODUCT, company_id, body
  }),
  updateProduct: (company_id, product_id, body) => ({
    type: actionType.UPDATE_PRODUCT,
    company_id,
    product_id,
    body
  }),
  deleteProduct: (company_id, product_id) => ({
    type: actionType.DELETE_PRODUCT,
    company_id,
    product_id
  })
}


// WEBPACK FOOTER //
// ./src/modules/company/pages/product/reducer.js